import React from 'react'
import { Footer } from './components/Footer/Footer'
import { Header } from './components/Header/Header'
import { Main } from './components/Main/Main'
import { GlobalStyle } from './styles/global'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'
import { I18nProvider } from './i18n/I18nProvider'
import { AuthProvider } from './contexts/AuthContext'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import PrivacyPolicy from './pages/PrivacyPolicy'
import CookiePolicy from './pages/CookiePolicy'
import CookieConsent from './components/CookieConsent/CookieConsent'
import { ChatWidget } from './components/ChatWidget/ChatWidget'
import { AdminRoute } from './components/AdminRoute/AdminRoute'
import { Projects } from './components/Projects/Projects'

const Game = React.lazy(() => import('./components/Game/Game'))
const BlogList = React.lazy(() => import('./pages/BlogList'))
const BlogPost = React.lazy(() => import('./pages/BlogPost'))
const AdminLogin = React.lazy(() => import('./pages/AdminLogin'))
const AdminBlogDashboard = React.lazy(() => import('./pages/AdminBlogDashboard'))
const AdminPostEditor = React.lazy(() => import('./pages/AdminPostEditor'))

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <GlobalStyle />
          <Header />
          <React.Suspense fallback={<div style={{ minHeight: '100vh' }} />}>
            <Routes>
              <Route path="/" element={<Main />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/game" element={<Game />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/blog" element={<AdminRoute><AdminBlogDashboard /></AdminRoute>} />
              <Route path="/admin/blog/new" element={<AdminRoute><AdminPostEditor /></AdminRoute>} />
              <Route path="/admin/blog/edit/:id" element={<AdminRoute><AdminPostEditor /></AdminRoute>} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              {/* fallback to main for unknown routes */}
              <Route path="*" element={<Main />} />
            </Routes>
          </React.Suspense>
          <Footer />
          <CookieConsent />
          <ChatWidget />
          <ToastContainer />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  )
}

export default App
